const isDev = import.meta.env.DEV;

interface LogMeta {
  [key: string]: unknown;
}

function format(level: string, message: string, meta?: LogMeta): void {
  if (!isDev) return;
  const prefix = `[shpaid:${level}]`;
  if (meta) {
    console[level as 'log' | 'warn' | 'error'](prefix, message, meta);
  } else {
    console[level as 'log' | 'warn' | 'error'](prefix, message);
  }
}

export const logger = {
  log:   (message: string, meta?: LogMeta) => format('log',   message, meta),
  warn:  (message: string, meta?: LogMeta) => format('warn',  message, meta),
  error: (message: string, meta?: LogMeta) => format('error', message, meta),
};

// Alias used by epsg.ts
export const log = logger;
